module.exports = __webpack_public_path__ + "media/react/marketing/components/testimonial_card/assets/blockquotes-6b15d5fe56979ad41c395cab100f992b.svg";